import React, { Component } from 'react'
import environment from '../../environment'
import { Select, Skeleton } from 'antd'
import { ErrorAlert } from './Alert'
import { Flex, FlexColumn } from './Container'
import { Button, TextButton } from './Button'
import { apiPOSTReq } from '../../Utils/api'
import { ONB_SAVE_DATA, REMOTE_SAVE_DATA, addDataToStore, CODAT_DATA } from '../../Actions/actions'
import { LabeledInput } from './Input'
import { connect } from 'react-redux'
import { withTheme } from 'styled-components'
import { Tag, Text } from './Text'
import { CheckCircleFilled, CheckCircleTwoTone } from '@ant-design/icons'
import { StyledLabel } from './Refresh/Input'
import { StyledExtLink } from './Link'
import { getDateInLocalTZ, toCurrency } from '../../Utils/util'
import SearchAndFilter from './SearchAndFilter'
import PageHeader from './PageHeader'
import TableView from './TableView'
import moment from 'moment'
import { InitialCircle } from './InitialCircle'
import hexToRgba from 'hex-to-rgba'

const { Option } = Select

class ExtBBTransactions extends Component {
    state = {
        loading: true,
        pagination: { pageSize: 50, current: 1 },
        account: this.props.account,
        institution: this.props.institution
    }

    componentDidMount() {
        this.fetchTransactions(this.state);
    }

    fetchTransactions = (options) => {
        var { transactionsList } = this.state;
        var { fromDate, toDate, searchStr, account, fromAmt, toAmt, viewBy, pagination, addToList } = options;

        var body = {
            accountId: account.accountId,
            pagination: options.pagination, // || pagination
            sortDirection: "DESC"
        }

        body.size = pagination.pageSize;
        body.page = pagination.current - 1;

        if (searchStr && searchStr != '') body.searchStr = searchStr;
        if (fromDate) body.fromDate = fromDate;
        if (toDate) body.toDate = toDate;
        if (fromAmt) body.fromAmt = fromAmt;
        if (toAmt) body.toAmt = toAmt;
        if (searchStr && searchStr != '') body.viewBy = 'SEARCH';

        body.providerStatus = "Pending|Posted";

        this.setState({ currentOptions: options, loading: true });

        apiPOSTReq(`${environment.integrationBaseUrl}/extbb/getTransactions`, {}, body, (err, resp) => {
            this.setState({ loading: false });
            try {
                const data = resp || {};
                if (data.result) {
                    var txnList = data.transactionsList || [];
                    if(addToList) txnList = transactionsList.concat(data.transactionsList || []);
                    this.setState({ transactionsList: txnList, pagination: pagination, moreToLoad: data.transactionsPageable });
                } else {
                    throw Error(data.error || data.responseMessage || "Could not fetch transactions.")
                }
            } catch (error) {
                console.log("ERRR getTransactions", error, resp);
                ErrorAlert({ description: error.message});
            }
        })
    }

    loadMoreActivity = () => {
        var { currentOptions } = this.state;
        var { pagination } = currentOptions;
        pagination.current += 1;
        currentOptions.addToList = true
        this.fetchTransactions(currentOptions);
    }

    columns = [
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            align: "left",
            render: (date, record) => getDateInLocalTZ(date, 'MMM DD, YYYY'),
            width: 140,
        },
        {
            title: 'Description',
            dataIndex: 'displayDescription',
            key: 'displayDescription',
            primaryCol: true,
            render: (desc, record) => desc,
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'Amount',
            align: "right",
            render: (amount, record) => {
                if (record.dateRow === true) {
                    return { props: { colSpan: 0 } }
                } else {
                    console.log("record.transactionType", record.transactionType)
                    return <Flex end centerHorizontally gap='24px'>
                        {
                            amount < 0 ?
                                <Text size='14px' noWrap weight='600' credit>+ {`$${toCurrency(Math.abs(amount))}`}</Text>
                                :
                                <Text size='14px' noWrap weight='600' color={this.props.theme.colors.defaultLightText}>- {`$${toCurrency(Math.abs(amount))}`}</Text>
                        }
                    </Flex>
                }
            },
            width: 140,
        }

    ];

    render() {
        var { loading, account, institution, moreToLoad, transactionsList, searchStr, currentOptions } = this.state
        return (
            <FlexColumn fullWidth start grow style={{ padding: '20px 40px', backgroundColor: '#F6F6F6', height: '110%' }}>
                <PageHeader
                    close
                    onClose={this.props.onClose}
                    fullpage
                    titleText={
                        <Flex start centerHorizontally gap='8px'>
                            <InitialCircle size={80} name={institution.bankName} useFirstWordOnly={true} logoUrl={institution.logoUrl} />
                            
                            <FlexColumn start gap='4px'>
                                <Flex start centerHorizontally gap='4px'>
                                    <Text size={'18px'} color={this.props.theme.colors.primary2}>{account.title}</Text>
                                </Flex>
                                <Text size={'14px'} height={'14px'} weight={500} color={hexToRgba(this.props.theme.colors.primary2, 0.5)}>{institution.bankName}</Text>
                            </FlexColumn>
                        </Flex>
                    }
                />
                <TableView
                    id="ext-txn"
                    loading={loading}
                    titleText={`Transaction history`}
                    descText={`Last updated at ${getDateInLocalTZ(institution.lastUpdatedAt, 'MMM D, YYYY; hh:mm A')}`}
                    pagination={false}
                    tableLayout='auto'
                    columns={this.columns}
                    dataSource={transactionsList}
                    rowKey={'transactionId'}
                                      
                    onLoadMore={() => this.loadMoreActivity()}
                    moreToLoad={moreToLoad}
                    loadingMore={loading}
                    pageSize={50}
                    borderView
                />
                <div style={{ height: '50px' }}></div>
            </FlexColumn>
        )
    }
}

function mapStateToProps(state) {
    return {
        onbStore: state.onboardingAppReducer,
        aionStore: state.aionAppReducer,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme(ExtBBTransactions))